import { ResourceCard } from "../../../ui/Learning/ResourceCard";
import { ResourceCardLayout } from "../../../ui/Learning/ResourceCardLayout";
import { isAllDisabled } from "../utils/util";

export function TopicList({topics,loading,onClick}) {
  return <ResourceCardLayout
        loading={!loading}
        total={topics.length}
        message="0 topics to show"
      >
        {topics.map((val) => (
          <ResourceCard
            key={val._id}
            name={val.name}
            thumbnail={val.thumbnail}
            onClick={() => onClick(val)}
            isDisabled={val.disabled || isAllDisabled(val.modules)}
          />
        ))}
      </ResourceCardLayout>
}